import halyardReady from './qscript.js';

const config = {
	host: 'sense-demo-staging.qlik.com',
	prefix: '/',
	port: 443,
	isSecure: true
};

window.require.config({
	baseUrl: (config.isSecure ? "https://" : "http://" ) + config.host + (config.port ? ":" + config.port : "" ) + config.prefix + "resources",
  paths: {
		qlik: (config.isSecure ? "https://" : "http://" ) + config.host + config.prefix + "resources/" + "js/qlik"
	}
});

export default new Promise((resolve) => {
  window.require( ["js/qlik"], function ( qlik ) {
    let app = qlik.sessionApp(config);
    halyardReady.then((halyard) => {
      app.setScript(halyard.getScript()).then(() => {
        app.doReload().then(() => {
          window.qapp = app;
          resolve(app);
        });
      });
    });
  });
});


// WEBPACK FOOTER //
// ./qapp.js